import * as React from 'react';
const SvgCloudArrowUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M22 13.5a4.5 4.5 0 0 1-4.5 4.5v-2a2.5 2.5 0 1 0-.649-4.915A4.003 4.003 0 0 0 13 6a4 4 0 0 0-3.91 4.848A3 3 0 1 0 7 16v2a5 5 0 1 1 .337-9.989A6.003 6.003 0 0 1 18.952 9.24 4.5 4.5 0 0 1 22 13.5"
    />
    <path
      fill="currentColor"
      d="M8.343 16.36h.01l-.038-.04c-.166-.174-.255-.268-.292-.37a.54.54 0 0 1 0-.31c.03-.11.13-.21.33-.41 0 0 3.106-3.11 3.337-3.18a.985.985 0 0 1 .621 0c.23.07 3.336 3.18 3.336 3.18l.038.04c.166.174.255.268.292.37.03.1.03.21 0 .31a.3.3 0 0 1-.06.11c-.06.08-.15.17-.28.3l-.28.28-.04.038c-.175.166-.269.255-.371.292-.1.03-.21.03-.31 0-.11-.03-.21-.13-.411-.33l-1.233-1.23v6.09c0 .28-.22.5-.501.5h-1.002c-.28 0-.5-.22-.5-.5v-6.09l-1.234 1.23-.04.038c-.174.166-.268.255-.37.292-.1.03-.21.03-.311 0a.5.5 0 0 1-.22-.14z"
    />
  </svg>
);
export default SvgCloudArrowUp;
